<script>
  // @ts-nocheck
  export let text;
</script>

<span
  class="whitespace-nowrap rounded-full bg-indigo-100 px-2.5 py-0.5 text-xs text-indigo-700 font-semibold uppercase"
>
  {text}
</span>
